import cn from "classnames";
import PanelTemplate from "components/shared/profile/panel";
import React from "react";
import { showDocumentAssignmentSettings, updateDocumentAssignmentSettings } from "sources/profile/organization";
import { config, initialState } from "./config";

class DocumentAssignmentSettings extends PanelTemplate {
    state = {
        data: { daysBeforeClosingDocumentAssignments: "" },
        isValid: true,
    };

    componentDidMount() {
        showDocumentAssignmentSettings().then((data) => this.setState({ data, initial: { ...data } }));
    }

    componentDidUpdate() {
        return undefined;
    }

    update = () => {
        const { data } = this.state;
        if (!this.isValidForm(data)) {
            return this.setState({ isValid: false });
        }
        return updateDocumentAssignmentSettings(data).then((res) => {
            if (!res) {
                this.setState({ isValid: false });
            }
            this.setState({ shouldUpdate: false });
        });
    };

    renderBody = () => {
        const { editable, config } = this.props;
        const { daysBeforeClosingDocumentAssignments } = config;
        return this.renderField({ ...daysBeforeClosingDocumentAssignments, disabled: !editable });
    };

    setValue = ({ value, name }) => {
        const data = { ...this.state.data, [name]: value };
        const shouldUpdate = this.compareStateAndInitial(data);
        const isValid = this.isValidForm(data);
        this.setState({ data, shouldUpdate, ...(isValid ? { isValid: true } : {}) });
    };

    compareStateAndInitial = (state) => {
        for (const key in state) {
            if (this.state.initial[key] !== state[key]) {
                return true;
            }
        }
        return false;
    };

    render() {
        const cname = cn("card card-body mb-3", {
            "border-danger": !this.state.isValid,
        });
        return (
            <div className={cname}>
                <div className="row">
                    <div className="col-sm-4">
                        <h5>Настройки сдачи документов</h5>
                    </div>
                    <div className="col-sm-8">
                        {this.renderBody()}
                        {this.renderButton()}
                    </div>
                </div>
            </div>
        );
    }
}

const ConfiguredPanel = (props) => (
    <DocumentAssignmentSettings {...props} config={config} initialState={initialState} />
);

export default ConfiguredPanel;
